import Vue from 'vue'
// import Vuetify from 'vuetify/lib/framework'
import Vuetify from 'vuetify/lib'
import '@/styles/main.scss'

// import de from '@/lang/vuetify/vuetify-de.json'
// import en from '@/lang/vuetify/vuetify-en.json'
// import es from '@/lang/vuetify/vuetify-es.json'
// import fr from '@/lang/vuetify/vuetify-fr.json'
// import nl from '@/lang/vuetify/vuetify-nl.json'

import icons from './icons'
import themes from './themes'
import components from './components'
import directives from './directives'

import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition'
const dialogLeftTransition = createSimpleTransition('dialog-left-transition')
Vue.component('DialogLeftTransition', dialogLeftTransition)
const dialogRightTransition = createSimpleTransition('dialog-right-transition')
Vue.component('DialogRightTransition', dialogRightTransition)

Vue.use(Vuetify, {
  components,
  directives,
})

export const getVuetify = ({ i18n }) => {
  return new Vuetify({
    icons,
    theme: {
      dark: false,
      themes,
      options: {
        // only for modern build!
        customProperties: true,
      },
    },
    lang: {
      t: (key, ...params) => i18n.t(key, params),
    },
  })
}
